/**
 * Сердце «в избранное».
 *
 * Стоит и на карточке каталога, и на странице квеста: откладывают на потом
 * чаще всего, пролистывая список, а не дочитав описание.
 *
 * Гостю кнопка не показывается вовсе: складывать некуда, а предлагать войти
 * ради сердечка — обещать больше, чем оно стоит.
 */
import { useTranslation } from "react-i18next";

import { useSetQuestFavorite } from "../api/queries";
import { useAuthStore } from "../stores/authStore";

export function FavoriteButton({
  questId,
  active,
  className = "",
  size = 18,
}: {
  questId: string;
  active: boolean;
  className?: string;
  size?: number;
}) {
  const { t } = useTranslation();
  const authenticated = useAuthStore((state) => state.status) === "authenticated";
  const toggle = useSetQuestFavorite();

  if (!authenticated) return null;

  return (
    <button
      type="button"
      className={`rounded-full p-1.5 transition-colors ${
        active ? "text-rust hover:text-rust/80" : "text-ink-400 hover:text-rust"
      } ${className}`}
      title={active ? t("favorites.remove") : t("favorites.add")}
      aria-label={active ? t("favorites.remove") : t("favorites.add")}
      aria-pressed={active}
      disabled={toggle.isPending}
      onClick={(event) => {
        // Кнопка часто лежит поверх карточки-ссылки: клик по сердцу не должен
        // уводить со страницы.
        event.preventDefault();
        event.stopPropagation();
        toggle.mutate({ questId, favorite: !active });
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={active ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="1.8"
        aria-hidden
      >
        <path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.55 11.48z" />
      </svg>
    </button>
  );
}
